import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/use-theme";
import { Moon, Sun } from "lucide-react";

/**
 * Single-button dark/light theme toggle for the global navbar.
 *
 * Shows a sun in dark mode (the action it takes) and a moon in light mode.
 * Persists via `localStorage("workloop:theme")` and reacts to other
 * sources (Cmd/Ctrl+Shift+T global shortcut, command palette) through the
 * MutationObserver inside useTheme.
 */
export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const nextLabel = isDark ? "light" : "dark";

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label={`Switch to ${nextLabel} theme`}
      title={`Theme: ${theme} (⌘⇧T)`}
      className="text-muted-foreground hover:text-foreground hover:bg-secondary"
    >
      {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </Button>
  );
}
